import React, { useState, useContext, useEffect, useRef } from "react";
import style from "../style/Login.module.scss";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import LittleFooter from "../components/LittleFooter";
import { LoginContext } from "../contexts/LoginContext";
import { AuthContext } from "../contexts/AuthContext";
import { useMutation, useQuery } from "react-query";
import LoginPromptModal from "../components/Icon/LoginPromptModal";
import Logger from "../libraries/Logger";
import apiClient from "../libraries/ApiClient";
import LoadingModal from "../components/Modal/LoadingModal";
import ReCAPTCHA from "react-google-recaptcha";
import { v4 as uuidv4 } from "uuid";
import Storage from "../libraries/StorageClient";

const CssTextField = styled((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "#ffffff",
      },
      "&.Mui-error": {
        borderColor: "#D92920",
        color: "#EB4D3D",
      },
    },
  })
);

const CssButton = styled(Button)({
  fontSize: 16,
  background: "#057AFF",
  "&:disabled": {
    border: "1px solid #d5d5d5",
    color: "#252525",
    background: "#E9E9E9",
  },
  "&:hover": {
    cursor: "pointer",
  },
});

function Login({ userId, setIsLoggedIn, loginAfter }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  const [openEye, setOpenEye] = useState(false);
  const [action, setAction] = useState("");
  const [rowId, setRowId] = useState("");
  const [liffId, setLiffId] = useState("");
  const [loadingIsOpen, setLoadingIsOpen] = useState(false);
  const [reCaptchaAppear, setReCaptchaAppear] = useState(false);
  const [reCaptchaIsDone, setReCaptchaIsDone] = useState(true);
  const [reCaptchaToken, setReCaptchaToken] = useState("");
  const [loginFailCount, setLoginFailCount] = useState(0);
  const [actionUuid, setActionUuid] = useState("");
  const captchaRef = useRef(null);

  console.log(userId);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setAction(params.get("action"));
    setRowId(params.get("rowId"));
    setLiffId(localStorage.getItem("liffId"));
    setActionUuid(localStorage.getItem("actionUuid"));
    setLoginFailCount(+localStorage.getItem("loginFailCount"));
    let data = JSON.stringify(loginFailCount);
    localStorage.setItem("loginFailCount", data);
    localStorage.removeItem("auth");
    localStorage.removeItem("actionUuid");
  }, []);

  useEffect(() => {
    if (loginFailCount > 0) {
      let data = JSON.stringify(loginFailCount);
      localStorage.setItem("loginFailCount", data);
    }
  }, [loginFailCount]);

  useEffect(() => {
    if (reCaptchaIsDone) {
      const reftoken = captchaRef.current?.getValue();
      setReCaptchaToken(reftoken);
    }
  }, [reCaptchaIsDone]);
  //console.log(reCaptchaToken);

  const {
    mailValue,
    passwordValue,
    mailValueIsValid,
    passwordValueIsValid,
    hasMailError,
    hasPasswordError,
    onChangeMailValue,
    onChangePasswordValue,
    onBlurMailValue,
    onBlurPasswordValue,
    reset,
  } = useContext(LoginContext);

  const { setMyAuth, SignalR } = useContext(AuthContext);

  const sendLoginData = async ({ liffId, mailValue, passwordValue }) => {
    if (!mailValueIsValid || !passwordValueIsValid) {
      return;
    }

    const lineUserId = localStorage.getItem("liffId");
    const data = {
      TestMode: 0,
      Data: {
        Account: mailValue,
        Password: passwordValue,
        LineUserId: userId,
        ActionUuid: actionUuid,
        GoogleReCaptchaToken: reCaptchaToken,
      },
    };
    //console.log(data);
    captchaRef.current?.reset();

    const result = await apiClient.postWithoutToken("api/login/security", data);

    if (result.status !== 200) {
      alert("登入失敗");
      return;
    } else {
      return result;
    }
  };

  const { mutate, isLoading: loginIsLoading } = useMutation(sendLoginData, {
    onSuccess: (data) => {
      //Logger.LogOfInfoWithIdentity("sendLoginData", data);
      const { Data: AuthData } = data.data || {};

      const {
        Account,
        AccountRowId,
        Token,
        Name,
        Result,
        Menus,
        Identities,
        OrganizationName,
        OrganizationCode,
        IsAdmin,
        AccountPermission,
        // IsOtherHospitalAccount,
      } = AuthData || {};
      //console.log(AuthData);

      const code = +data?.data.Code;

      if (code === 2) {
        const LocalstorageData = {
          authorized: true,
          AccountRowId: AccountRowId,
          Name: Name,
          Account: Account,
          Token: Token,
          Menu: Menus,
          SelfIdentities: Identities?.landseed_zonedefense_tbc,
          OtherIdentities: Identities?.other_zonedefense_tbc,
          Hospital: OrganizationName,
          HospitalCode: OrganizationCode,
          IsAdmin: IsAdmin,
          AccountPermission: AccountPermission,
          // IsOtherHospital: IsOtherHospitalAccount,
        };
        //console.log(LocalstorageData);
        localStorage.setItem("auth", JSON.stringify(LocalstorageData));
        localStorage.removeItem("loginFailCount");
        setMyAuth({ ...LocalstorageData, authorized: true });
        alert("前往首次驗證");
        navigate("/FirstLogin");
        reset();
        return;
      } else if (code === 0) {
        switch (Result) {
          case 1:
            const LocalstorageData = {
              authorized: true,
              AccountRowId: AccountRowId,
              Name: Name,
              Account: Account,
              Token: Token,
              Menu: Menus,
              SelfIdentities: Identities?.landseed_zonedefense_tbc,
              OtherIdentities: Identities?.other_zonedefense_tbc,
              Hospital: OrganizationName,
              HospitalCode: OrganizationCode,
              IsAdmin: IsAdmin,
              AccountPermission: AccountPermission,
              // IsOtherHospital: IsOtherHospitalAccount,
            };
            //console.log(LocalstorageData);
            // Logger.LogOfInfoWithIdentity("首次帳號登入Token", Token);
            localStorage.setItem("auth", JSON.stringify(LocalstorageData));
            localStorage.removeItem("loginFailCount");
            setMyAuth({ ...LocalstorageData, authorized: true });

            const actionUuid = uuidv4();
            localStorage.setItem("actionUuid", actionUuid);

            alert("登入成功");
            navigate(
              loginAfter === "/DoctorSchedule"
                ? "/DoctorSchedule"
                : "/ReferralDataList"
            );
            setIsLoggedIn(true);
            reset();
            break;
        }
      } else if (code === 1) {
        setLoginFailCount(+loginFailCount + 1);
        switch (Result) {
          case 2:
            alert("帳號或密碼不符合");
            break;
          case 3:
            alert("帳號已失效");
            break;
          case 4:
            alert("帳號遭到鎖定");
            break;
          case 5:
            alert("帳號尚未驗證");
            break;
          case 6:
            alert("帳號已停用");
            break;
          case 7:
            alert("帳號尚未啟用");
            break;
          case 99:
            alert("未知錯誤");
            break;
          default:
            return;
        }
      }
    },
  });

  const checkToken = async ({ queryKey }) => {
    const [_, token] = queryKey;

    const data = {
      Data: {
        Token: token,
      },
    };

    const res = await apiClient.postAes(
      "api/login/validation/token/security",
      data
    );
    return res?.data;
  };
  const { data: TokenData, isLoading: tokenCheckLoading } = useQuery(
    ["checkToken", token],
    checkToken,
    {
      refetchOnWindowFocus: false,
      enabled: !!token,
    }
  );
  //console.log(TokenData?.Code);

  const ReCaptchaHandler = () => {
    setReCaptchaIsDone(!reCaptchaIsDone);
  };

  useEffect(() => {
    if (loginFailCount >= 8) {
      setReCaptchaAppear(true);
      setReCaptchaIsDone(false);
    }
  }, [loginFailCount]);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  }, []);

  useEffect(() => {
    if (+TokenData?.Code === 0 && action === "referraladd") {
      navigate("/ReferralAddData");
    } else if (
      (+TokenData?.Code === 0 && action === "querypatient") ||
      (+TokenData?.Code === 0 && action === "referralreply")
    ) {
      navigate("/ReferralDataList");
    } else if (+TokenData?.Code === 0 && action === "referralfeedback") {
      navigate("/History");
    } else if (+TokenData?.Code === 0 && action === "referraledit") {
      navigate("/ReferralEditData?rowId=" + rowId);
    } else {
      return;
    }
  }, [TokenData]);

  if (tokenCheckLoading) {
    return <h1>tokenCheckLoading....</h1>;
  }

  // const test = async () => {
  //   const res = await axios.get(
  //     "http://192.168.60.107/ZoneDefenseWebApi/api/login/aestest01"
  //   );
  //   console.log(res);

  //   let pass = CryptoJS.AES.decrypt(
  //     res.data,
  //     CryptoJS.enc.Latin1.parse("1234567890123456"),
  //     {
  //       iv: CryptoJS.enc.Latin1.parse("1234567890123456"),
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7,
  //     }
  //   );

  //   let passReset = pass.toString(CryptoJS.enc.Utf8);
  //   console.log(passReset);
  // };

  // const sendTest = async () => {
  //   let pass = CryptoJS.AES.encrypt(
  //     "0621測試",
  //     CryptoJS.enc.Latin1.parse("1234567890123456"),
  //     {
  //       iv: CryptoJS.enc.Latin1.parse("1234567890123456"),
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7,
  //     }
  //   );

  //   let passReset = pass.toString();
  //   console.log(passReset);
  //   const res = await axios.post(
  //     "http://192.168.60.107/ZoneDefenseWebApi/api/login/aestest02",
  //     passReset,
  //     {
  //       headers: {
  //         "Content-Type": "text/plain",
  //       },
  //     }
  //   );
  //   let passTwo = CryptoJS.AES.decrypt(
  //     res.data,
  //     CryptoJS.enc.Latin1.parse("1234567890123456"),
  //     {
  //       iv: CryptoJS.enc.Latin1.parse("1234567890123456"),
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7,
  //     }
  //   );

  //   let passResetTwo = JSON.parse(passTwo.toString(CryptoJS.enc.Utf8));
  //   console.log(passResetTwo);
  // };

  return (
    <div className={style.login_body}>
      <div className={style.login_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.form_body}>
        <div className={style.logo}>
          <img src="./end_logo.svg" alt="" style={{ width: "20%" }} />
        </div>
        <div className={style.login_form}>
          <div className={style.login_form_top}>
            <div className={style.form_title}>登入區域聯防轉診平台</div>
            {/* <button onClick={test}>按下去</button>
            <button onClick={sendTest}>送出去</button> */}
            <div className={style.form_little_title}>
              還沒帳號嗎?
              <LoginPromptModal />
            </div>
          </div>
          <div className={style.input_content}>
            <div className={style.input_mail}>
              <CssTextField
                label="請輸入帳號信箱/手機/員工編號"
                variant="filled"
                onChange={onChangeMailValue}
                onBlur={onBlurMailValue}
                value={mailValue}
                error={hasMailError ? true : false}
                style={{ width: "100%" }}
              />
              <div
                style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}
              >
                {hasMailError && "帳號不可有空白"}
              </div>
            </div>
            <div className={style.input_password}>
              <div style={{ position: "relative" }}>
                <CssTextField
                  label="請輸入密碼"
                  variant="filled"
                  type={`${openEye ? null : "password"}`}
                  onChange={onChangePasswordValue}
                  onBlur={onBlurPasswordValue}
                  value={passwordValue}
                  error={hasPasswordError ? true : false}
                  style={{ width: "100%" }}
                />
                <i
                  className={`fa-solid ${style.eye_btn} ${
                    openEye ? "fa-eye" : "fa-eye-slash"
                  }`}
                  onClick={() => {
                    setOpenEye(!openEye);
                  }}
                ></i>
              </div>
              <div
                style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}
              >
                {hasPasswordError &&
                  "密碼請輸入英數組合至少8碼，避免特殊符號或空白"}
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Link
                to="/ForgetPassword"
                style={{
                  textAlign: "end",
                  textDecoration: "none",
                  color: "#057AFF",
                }}
              >
                忘記密碼?
              </Link>
            </div>
            {reCaptchaAppear && (
              <ReCAPTCHA
                sitekey={import.meta.env.VITE_RE_CAPTCHA_KEY}
                onChange={ReCaptchaHandler}
                ref={captchaRef}
                style={{ display: "flex", justifyContent: "center" }}
              ></ReCAPTCHA>
            )}

            <CssButton
              variant="contained"
              disabled={
                !reCaptchaIsDone ||
                !mailValueIsValid ||
                !passwordValueIsValid ||
                loginIsLoading
              }
              onClick={() => {
                mutate({ liffId, mailValue, passwordValue });
              }}
            >
              登入
            </CssButton>
            <Button
              variant="outlined"
              disabled={!reCaptchaIsDone || loginIsLoading}
              onClick={() => {
                navigate("/TempAccount");
              }}
            >
              建立臨時帳號
            </Button>

            <LoadingModal isOpen={loginIsLoading} />
          </div>
        </div>
      </div>
      <LittleFooter />
    </div>
  );
}

export default Login;
